'use strict';

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var videoLayout = require('./videoLayout');

function wixVideoWrapper(WixElement, services, environmentConsts) {
  var wixVideo =
  /*#__PURE__*/
  function (_WixElement) {
    _inheritsLoose(wixVideo, _WixElement);

    function wixVideo() {
      // eslint-disable-line no-useless-constructor
      return _WixElement.call(this) || this;
    }

    var _proto = wixVideo.prototype;

    _proto.reLayout = function reLayout() {
      var _this = this;

      var videoSourceUrl;
      var needsSrcUpdate;
      var videoStyle;

      var _JSON$parse = JSON.parse(this.dataset.videoInfo),
          isVideoDataExists = _JSON$parse.isVideoDataExists,
          videoWidth = _JSON$parse.videoWidth,
          videoHeight = _JSON$parse.videoHeight,
          qualities = _JSON$parse.qualities,
          videoId = _JSON$parse.videoId,
          videoFormat = _JSON$parse.videoFormat,
          alignType = _JSON$parse.alignType,
          fittingType = _JSON$parse.fittingType,
          hasBgScrollEffect = _JSON$parse.hasBgScrollEffect,
          autoPlay = _JSON$parse.autoPlay,
          animatePoster = _JSON$parse.animatePoster,
          containerId = _JSON$parse.containerId,
          isEditorMode = _JSON$parse.isEditorMode;

      var autoPlayAllowed = !environmentConsts.prefersReducedMotion && autoPlay;
      var container = document.querySelector("#" + containerId);
      var videoNode;
      var poster;
      var canvas;
      services.mutationService.measure(function () {
        if (isVideoDataExists) {
          videoNode = _this.querySelector("video[id^=\"" + containerId + "\"]");
          poster = container.querySelector(".bgVideoposter[id^=\"" + containerId + "\"]");
          canvas = container.querySelector(".webglcanvas[id^=\"" + containerId + "\"]");
          var measures = videoLayout.measure(videoNode, container, hasBgScrollEffect, videoWidth, videoHeight, fittingType, alignType, qualities, environmentConsts.staticVideoUrl, videoId, videoFormat);
          videoSourceUrl = measures.videoSourceUrl;
          needsSrcUpdate = measures.needsSrcUpdate;
          videoStyle = measures.videoStyle;
        }
      });
      services.mutationService.mutate(function () {
        if (isVideoDataExists) {
          videoLayout.mutate(poster, canvas, videoNode, videoStyle, autoPlayAllowed, videoSourceUrl, needsSrcUpdate, animatePoster, videoFormat, isEditorMode);
        }
      });
    };

    _proto.attributeChangedCallback = function attributeChangedCallback(name, oldValue) {
      if (oldValue) {
        this.reLayout();
      }
    };

    _createClass(wixVideo, null, [{
      key: "observedAttributes",
      get: function get() {
        return ['data-video-info'];
      }
    }]);

    return wixVideo;
  }(WixElement);

  return wixVideo;
}

module.exports = wixVideoWrapper;
//# sourceMappingURL=wixVideo.js.map